import * as Yup from 'yup';

export const ProductAdjustmentItemFormSchema = () =>
  Yup.object({
    productVariantId: Yup.object({
      id: Yup.string().default(''),
      label: Yup.string().default(''),
    }),
    type: Yup.string().default(''),
    description: Yup.string().default(''),
    stock: Yup.number(),
    qty: Yup.number().default(0).min(1),
    price: Yup.number(),
    totalPrice: Yup.number(),
    //additional information
    customId: Yup.string().default(''),
    tempPrice: Yup.number().default(0),
  });

export const ProductAdjustmentFormSchema = () =>
  Yup.object({
    transactionAt: Yup.date().default(new Date()),
    description: Yup.string().default(''),
    items: Yup.array(ProductAdjustmentItemFormSchema()).default([]),
  });

export type ProductAdjustmentItemFormType = Yup.InferType<
  ReturnType<typeof ProductAdjustmentItemFormSchema>
>;

export type ProductAdjustmentFormType = Yup.InferType<
  ReturnType<typeof ProductAdjustmentFormSchema>
>;
